import { AxiosResponse } from "axios";
import { PostDecreaseCreditLimitParams } from "components/ReduceCreditLimit/types";
import { withPath } from "./api";
import { getHref, postHref } from "./httpMethods";
import { definitions, responses } from "./service-cards.generated";
import {
  ActivateCreditCardOtpResponse,
  ActivateCreditCardResponse,
  DecreaseCreditCardResponse,
} from "./types";

interface PostCardActivateParams {
  data: {
    card_expiry_date: {
      month: number;
      year: number;
    };
  };
  id: string;
}
export const postCardActivate = ({
  data,
  id,
}: PostCardActivateParams): Promise<
  AxiosResponse<ActivateCreditCardResponse>
> => postHref(withPath(`v1/cards/${id}/activate`), data);

interface PostCardActivateOtpParams {
  data: { otp: string };
  id: string;
}
export const postCardActivateOtp = ({
  data,
  id,
}: PostCardActivateOtpParams): Promise<
  AxiosResponse<ActivateCreditCardOtpResponse>
> => postHref(withPath(`v1/cards/${id}/activate/otp`), data, {}, true);

export const postCardActivateOtpResend = (
  accountId: string,
): Promise<AxiosResponse<ActivateCreditCardResponse>> =>
  postHref(withPath(`v1/cards/${accountId}/activate/otp/resend`));

export const postDecreaseCreditLimit = ({
  linkUrl,
  newCreditLimit,
}: PostDecreaseCreditLimitParams): Promise<
  AxiosResponse<DecreaseCreditCardResponse>
> => postHref(linkUrl, { credit_limit: newCreditLimit });

// TODO: zendesk integration needs to be added.
export const postAdditionalCardHolder = () =>
  new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

// TODO: zendesk integration needs to be added.
export const postThirdPartyAuthority = () =>
  new Promise((resolve) => {
    setTimeout(resolve, 500);
  });

export const getTempCardLock = (
  token: string,
): Promise<AxiosResponse<responses["cardLockResponse"]["schema"]>> =>
  getHref(withPath(`v1/cards/${token}/lock`));

export const postTempCardLock = (
  token: string,
  payload: definitions["CardLockRequest"],
): Promise<AxiosResponse<responses["cardLockResponse"]["schema"]>> =>
  postHref(withPath(`v1/cards/${token}/lock`), payload);
